import { lazyPage } from './lazyPage';
import type { AppRoute } from './types';

const ModuleMenu = lazyPage(() => import('@/pages/ModuleMenu'));
const TimetableOverview = lazyPage(() => import('@/pages/timetable/Overview'));
const BellSchedules = lazyPage(() => import('@/pages/timetable/BellSchedules'));
const StudentGroups = lazyPage(() => import('@/pages/timetable/StudentGroups'));
const Activities = lazyPage(() => import('@/pages/academics/Activities'));
const TeacherAvailability = lazyPage(() => import('@/pages/timetable/TeacherAvailability'));
const RoomsResources = lazyPage(() => import('@/pages/timetable/RoomsResources'));
const RoomDetails = lazyPage(() => import('@/pages/timetable/RoomDetails'));
const Constraints = lazyPage(() => import('@/pages/timetable/Constraints'));
const GenerateTimetable = lazyPage(() => import('@/pages/timetable/GenerateTimetable'));
const TimetableEditor = lazyPage(() => import('@/pages/timetable/TimetableEditor'));
const Substitution = lazyPage(() => import('@/pages/timetable/Substitution'));
const TimeTables = lazyPage(() => import('@/pages/timetable/TimeTables'));
const TimetableReports = lazyPage(() => import('@/pages/timetable/Reports'));

export const TIMETABLE = '/administrator/timetable';

export const timetableRoutes: AppRoute[] = [
  {
    path: 'timetable',
    title: 'Timetable',
    children: [
      { path: '', title: 'Timetable', component: ModuleMenu },
      { path: 'overview', title: 'Overview', component: TimetableOverview, yearScoped: true },
      { path: 'bell-schedules', title: 'Bell Schedules', component: BellSchedules, yearScoped: true },
      { path: 'student-groups', title: 'Student Groups', component: StudentGroups, yearScoped: true },
      { path: 'activities', title: 'Activities', component: Activities, yearScoped: true },
      { path: 'teacher-availability', title: 'Teachers Availability', component: TeacherAvailability, yearScoped: true },
      { path: 'rooms-resources', title: 'Rooms & Resources', component: RoomsResources, yearScoped: true },
      { path: 'rooms-resources/:roomId', title: 'Room Details', component: RoomDetails, yearScoped: true },
      { path: 'constraints', title: 'Constraints', component: Constraints, yearScoped: true },
      { path: 'generate', title: 'Generate Timetable', component: GenerateTimetable, yearScoped: true },
      { path: 'editor', title: 'Timetable Editor', component: TimetableEditor, yearScoped: true },
      { path: 'substitution', title: 'Substitution', component: Substitution, yearScoped: true },
      { path: 'timetables', title: 'Time Tables', component: TimeTables, yearScoped: true },
      { path: 'reports', title: 'Timetable Reports', component: TimetableReports, yearScoped: true },
    ],
  },
];
